// extracted by mini-css-extract-plugin
module.exports = {"mapHeader":"dTz8TX","right":"JOxsFl","slice":"WSqNO1","period":"uSlMSP","base":"_7C_n8l","dot":"qH1Q5c","time":"gqV3ip"};